// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-direct-deposit-direct-deposit-js": () => import("/github/workspace/src/templates/DirectDeposit/direct-deposit.js" /* webpackChunkName: "component---src-templates-direct-deposit-direct-deposit-js" */),
  "component---src-templates-pay-bills-pay-bills-js": () => import("/github/workspace/src/templates/PayBills/pay-bills.js" /* webpackChunkName: "component---src-templates-pay-bills-pay-bills-js" */),
  "component---src-pages-404-js": () => import("/github/workspace/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/github/workspace/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import("/github/workspace/.cache/data.json")

